import { useIntercom } from '@zenbusiness/application-commons-intercom';
import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import ContactMethods from '#client/components/ContactMethods';
import SharedAsset from '#client/components/SharedAsset';

import useStyles from './useStyles';

// Images
// eslint-disable-next-line react/jsx-props-no-spreading
const HelpImage = (props) => (<SharedAsset src="/illustration/faq-header.svg" width={240} alt="" {...props} />);

const Help = () => {
  const classes = useStyles();
  const { update: updateIntercom } = useIntercom();
  if (window.Intercom) {
    // show intercom when in help page
    updateIntercom({ hide_default_launcher: false });
  }
  return (
    <section className={classes.root}>
      <Title
        level={1}
        variant="lg-alt"
        className={classes.heading1}
      >
        Get Help
      </Title>
      <Paper className={classes.helpBox}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid
            item
            className={`${classes.gridSpacing} ${classes.helpBoxImgWrapper}`}
            xs={12}
            sm
          >
            <HelpImage className={classes.helpBoxImg} />
          </Grid>
          <Grid
            item
            className={`${classes.gridSpacing} ${classes.helpBoxTextWrapper}`}
            xs={12}
            sm
          >
            <Title
              className={classes.helpBoxHeader}
              variant="md-alt"
            >
              Find an Answer in Our Help&nbsp;Center
            </Title>
            <Text className={classes.helpBoxBody}>
              Get help with changing your order,
              setting up your domain,
              setting up your new business email address,
              and&nbsp;more!
            </Text>
          </Grid>
          <Grid
            item
            className={`${classes.gridSpacing} ${classes.helpCenterBtnWrapper}`}
            xs={12}
            sm={12}
            md
          >
            <Button
              className={classes.helpCenterBtn}
              color="primary"
              variant="contained"
              target="_blank"
              href="https://intercom.help/zenbusiness/en"
              size="small"
            >
              Search Help Center
            </Button>
          </Grid>

        </Grid>
      </Paper>
      <Title
        variant="md-alt"
        className={classes.supportContactHeader}
      >
        Support Team Contact&nbsp;Information
      </Title>
      <ContactMethods headingLevel="h3" />
    </section>
  );
};

export default Help;
